import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import Page from '../Page';
import Camera from './camera/Camera';
import Gyro from './gyro/Gyro';
import './Intro.sass';
import Scanning from './scanning/Scanning';
import Start from './start/Start';


const Intro = ({ onFinished }) => {
	const [hasIntroStarted, setHasIntroStarted] = useState(false);
	const [isIntroDone, setIsIntroDone] = useState(false);
	const [lastRequestOriginSlide, setLastRequestOriginSlide] = useState(null);

	const [swiper, setSwiper] = useState(null);

	const slideNext = (origin) => {
		if (swiper.isEnd) setIsIntroDone(true);
		else if (origin !== lastRequestOriginSlide) {
			swiper.slideNext(300);
			setHasIntroStarted(true);
			setLastRequestOriginSlide(origin);
		}
	};
	const slidePrev = (origin) => {
		swiper.slidePrev();
		setLastRequestOriginSlide(origin);
	}

	useEffect(() => {
		if (isIntroDone && swiper) {
			swiper.destroy(true, true);
			setSwiper(null);
			onFinished();
		}
	}, [hasIntroStarted, isIntroDone, swiper, onFinished]);

	if (isIntroDone) return <></>;

	return <Page className="intro">
		<Swiper
			navigation
			allowTouchMove={false}
			onSwiper={setSwiper}>

			<SwiperSlide>
				<Start onNextSlideRequested={slideNext} />
			</SwiperSlide>
			<SwiperSlide>
				<Camera isCurrentSlide={hasIntroStarted} onNextSlideRequested={slideNext} onPrevSlideRequested={slidePrev} />
			</SwiperSlide>
			{/iPad|iPhone|iPod/.test(navigator.platform) && <SwiperSlide>
				<Gyro onPrevSlideRequested={slidePrev} onNextSlideRequested={slideNext} />
			</SwiperSlide>}
			<SwiperSlide>
				<Scanning onNextSlideRequested={slideNext} />
			</SwiperSlide>
		</Swiper>
	</Page>
};

Intro.propTypes = {
	onFinished: PropTypes.func.isRequired
}

export default Intro;

